import { lazy, Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { AppHeader } from './components/AppHeader'
import { LoadingState } from './components/LoadingState'
import { NotFoundPage } from './pages/NotFoundPage'

const PortfolioPage = lazy(async () => ({ default: (await import('./pages/PortfolioPage')).PortfolioPage }))
const StationPage = lazy(async () => ({ default: (await import('./pages/StationPage')).StationPage }))

export function App() {
  return (
    <div className="app-shell">
      <a className="skip-link" href="#main-content">Skip to main content</a>
      <AppHeader />
      <Suspense fallback={<main id="main-content" className="page-shell"><LoadingState label="Loading interface" /></main>}>
        <Routes>
          <Route path="/" element={<PortfolioPage />} />
          <Route path="/stations/:stationId" element={<StationPage />} />
          <Route path="/network" element={<Navigate to="/" replace />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
    </div>
  )
}
